import {
  SHOW_LOADING,
  GET_CAMPAIGN,
  LOAD_CAMPAIGN,
  UPDATE_CAMPAIGN,
  CREATE_CAMPAIGN,
  GET_CAMPAIGN_TEMPLATE_TYPES,
  LOAD_CAMPAIGN_TEMPLATE_TYPES,
  GET_WHATSAPP_NUMBERS,
  SAVE_WHATSAPP_NUMBERS,
  RESET_CAMPAIGN,
} from "../constants/Campaign";
const initState = {
  loading: false,
  campaigns: [],
  campaignTemplateTypes: [],
  whatsappNumbers: [],
};

const campaign = (state = initState, action) => {
  switch (action.type) {
    case GET_CAMPAIGN:
      return {
        ...state,
        loading: false,
      };
    case UPDATE_CAMPAIGN:
      return {
        ...state,
        loading: false,
      };
    case RESET_CAMPAIGN:
      return {
        loading: false,
        campaigns: [],
        campaignTemplateTypes: [],
        whatsappNumbers: [],
      };
    case CREATE_CAMPAIGN:
    console.log("REDUCED CALLED");  
    return {
        ...state,
        loading: false,
      };
    case LOAD_CAMPAIGN:
      return {
        ...state,
        loading: false,
        campaigns: [...action.payload],
      };
    case GET_CAMPAIGN_TEMPLATE_TYPES:
      return {
        ...state,
        loading: false,
      };
    case SHOW_LOADING: {
      return {
        ...state,
        loading: true,
      };
    }
    case LOAD_CAMPAIGN_TEMPLATE_TYPES: {
      return {
        ...state,
        campaignTemplateTypes: [...action.payload],
      };
    }
    case GET_WHATSAPP_NUMBERS: {
      return {
        ...state,
        loading: true,
      };
    }
    case SAVE_WHATSAPP_NUMBERS: {
      return {
        ...state,
        loading: false,
        whatsappNumbers: [...action.payload],
      };
    }
    default:
      return state;
  }
};

export default campaign;
